import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {withTranslation} from 'react-i18next'
class APIFailScreen extends Component{
    render(){
        const {t} = this.props
        return(
            <section className="overlay">
                <div className="overlay-window-container">
                    <div className="overlay-window no-bg error">
                        <div className="overlay-content">
                            <div className="header">
                                {/* <div className="header-icon">
                                    <i className="fas fa-times"></i>
                                    <p>Validation failed</p>
                                </div> */}
                                <div className="header-text api-fail-heading-checkin">
                                    <h3 style={{fontWeight: "normal"}}>{t('camera.error_texts')}</h3>
                                </div>
                            </div>
                            <div className="hotel-logo">
                                {/* Please contact the hotel reception. */}
                                {!this.props.errorMsg? "": this.props.errorMsg === "resourceUnauthorized" ?  t("freedomPay.error.session_timeout")  :this.props.errorMsg}
                            </div>
                        </div>
                        <div className="overlay-controls">
                            {this.props.nextPath ? <Link exact to={this.props.nextPath} className = "button"
                               
                                style = {{
                                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                                    color: this.props.menuColor.assetFontSelectorColor
                                }}
                                >{t('profile.close_btn')}
                            </Link>
                            : <button className="button"
                                style = {{
                                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                                    color: this.props.menuColor.assetFontSelectorColor
                                }}
                            onClick = {this.props.backBtn}>{t('profile.close_btn')}</button>}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,

    }
  }

export default connect(mapStateToProps)(withTranslation('translations')(APIFailScreen));